import React from 'react';
import ZonesList from './ZonesList';
import type { MarketZoneId, MarketZone } from '@app/common/static-data/energy-markets';

interface MapContainerProps {
  activeTab: 'list' | 'map';
  mapContainerRef: React.RefObject<HTMLDivElement>;
  zonesLoaded: boolean;
  zonesReloading?: boolean;
  selectedZones: MarketZoneId[];
  onZonesChange: (zones: MarketZoneId[]) => void;
  availableZones?: MarketZone[];
  zonesReady?: boolean;
}

const MapContainer: React.FC<MapContainerProps> = ({
  activeTab,
  mapContainerRef,
  zonesLoaded,
  zonesReloading = false,
  selectedZones,
  onZonesChange,
  availableZones,
  zonesReady = true,
}) => {
  return (
    <div className="flex-1 relative">
      {/* Map Container - Always rendered but hidden when not active */}
      <div
        className={`absolute inset-0 w-full h-full ${activeTab === 'map' ? 'visible' : 'invisible pointer-events-none'}`}
      >
        <div
          ref={mapContainerRef}
          className="absolute inset-0 w-full h-full"
          style={{ minHeight: '200px' }}
        />
        {!zonesReady && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-50 dark:bg-gray-700">
            <div className="text-center">
              <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600 dark:border-gray-600 dark:border-t-blue-400"></div>
              <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">Loading zones...</div>
            </div>
          </div>
        )}
        {zonesReady && !zonesLoaded && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-50 dark:bg-gray-700">
            <div className="text-center">
              <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600 dark:border-gray-600 dark:border-t-blue-400"></div>
              <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">Loading map...</div>
            </div>
          </div>
        )}
        {zonesReloading && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-50/80 dark:bg-gray-700/80 backdrop-blur-sm">
            <div className="text-center">
              <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600 dark:border-gray-600 dark:border-t-blue-400"></div>
              <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">Updating zones...</div>
            </div>
          </div>
        )}
      </div>

      {/* List View */}
      {activeTab === 'list' && (
        <ZonesList
          selectedZones={selectedZones}
          onZonesChange={onZonesChange}
          zonesLoaded={zonesLoaded}
          availableZones={availableZones}
        />
      )}
    </div>
  );
};

export default MapContainer;
